import { configureStore } from "@reduxjs/toolkit";

import stepperSlice from "./stepper-slice";
import answersSlice from "./answers-slice";
import platformSlice from "../../platform/store/platform-slice";
import serviceLogicBuilderSlice from "../../platform/store/service-logic-builder-slice";

const store = configureStore({
  reducer: {
    stepper: stepperSlice.reducer,
    answers: answersSlice.reducer,
    platform: platformSlice.reducer,
    serviceLogicBuilder: serviceLogicBuilderSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;
